module.exports = __webpack_public_path__ + "img/scan (13).3171a8bc.png";